"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoRooms/List/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _EmptyRoomsList = require('web/components/VideoRooms/List/EmptyRoomsList'); var _EmptyRoomsList2 = _interopRequireDefault(_EmptyRoomsList);
var _RoomPreview = require('web/screens/VideoRooms/List/RoomPreview'); var _RoomPreview2 = _interopRequireDefault(_RoomPreview);










const MeetingsList = ({
  gotoRoom,
  roomsList,
  currentRoomKey,
  onArchive, onUnarchive,
}) => {
  if (roomsList.length === 0) { return _react2.default.createElement(_EmptyRoomsList2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 20}} ) }

  return (
    _react2.default.createElement('div', { className: "meeting-rooms--rooms-list", __self: this, __source: {fileName: _jsxFileName, lineNumber: 23}}
      , 
        roomsList.map(r => {
          // SAFETY: the list comes from selectRelevantRoomsList, which keeps
          // only rooms whose RoomKey is among the search's matching keys.
          const roomKey = r.RoomKey 
          const isActive = currentRoomKey === roomKey
          // The JS also passed `gotoRoom` to the row, which never read it.
          return (
            _react2.default.createElement(_RoomPreview2.default, {
              key: roomKey,
              roomKey: roomKey,
              onPick: () => !isActive && gotoRoom(roomKey),
              onToggleArchivation: () => r.Archived
                ? onUnarchive(roomKey)
                : onArchive(roomKey)
              ,
              isActive: isActive,
              isArchived: r.Archived,
              roomName: r.DisplayName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 32}}
            )
          )
        })
      
    )
  )
}

exports. default = MeetingsList
